/**
 * Референс как сцена генерации: карточка `/api/reference-items/:id/card` и пачка строк
 * `/api/reference-items/cards?ids=` (форма — `reels/references.py`).
 */
import { apiFetch, query } from "@/lib/api";
import type { FittingsResult } from "@/lib/fitting";
import type { ReferenceItem } from "@/lib/library";

export type ReferenceCard = {
  item: ReferenceItem & { generations: number };
  library: {
    id: number;
    name: string;
    note: string | null;
    category_code: string;
    category_name: string;
  };
  spent: { count: number; cost: number };
  generated_dress_ids: number[];
  generations: FittingsResult;
};

/** Строка референса с платьями, по которым уже генерировали. */
export type ReferenceLite = ReferenceItem & { generated_dress_ids: number[] };

export const referenceKeys = {
  card: (id: number) => ["reference", id] as const,
  cards: (ids: number[]) => ["references", ids.join(",")] as const,
};

export const loadReferenceCard = (id: number) =>
  apiFetch<ReferenceCard>(`/api/reference-items/${id}/card`);
export const loadReferenceCards = (ids: number[]) =>
  apiFetch<{ items: ReferenceLite[] }>(
    "/api/reference-items/cards" + query({ ids: ids.join(",") }),
  );
